// @flow

import React, { type Node } from 'react';

export type SensitiveDataProps = {
  children: Node,
};

// This component adds an `fs-hide` class to all `children`
// which will hide them from FullStory. Use it to wrap senstive
// data like credit card fields, etc.
// Note that the children _must_ accept and apply a `className` prop
// for this to work properly!
const SensitiveData = ({ children }: SensitiveDataProps) => {
  return (
    <React.Fragment>
      {React.Children.map(children, child => {
        return React.cloneElement(child, {
          className: `fs-hide ${child.props.className || ''}`.trim(),
        });
      })}
    </React.Fragment>
  );
};

export default SensitiveData;
